/**
 * Abbreviate a dollar amount for KPI cards and badges.
 *
 * Examples:
 *   fmtMoneyShort(500)       → "$500"
 *   fmtMoneyShort(8835)      → "$8.8K"
 *   fmtMoneyShort(883500)    → "$883.5K"
 *   fmtMoneyShort(1200000)   → "$1.2M"
 */
/**
 * Format a dollar amount with full precision (no abbreviation).
 *
 * Examples:
 *   fmtMoney(500)       -> "$500"
 *   fmtMoney(8835)      -> "$8,835"
 *   fmtMoney(1200000)   -> "$1,200,000"
 */
export function fmtMoney(n: number): string {
  return '$' + Math.round(n).toLocaleString()
}

/**
 * Abbreviate a dollar amount for KPI cards and badges.
 *
 * Examples:
 *   fmtMoneyShort(500)       -> "$500"
 *   fmtMoneyShort(8835)      -> "$8.8K"
 *   fmtMoneyShort(883500)    -> "$883.5K"
 *   fmtMoneyShort(1200000)   -> "$1.2M"
 */
export function fmtMoneyShort(n: number): string {
  const abs = Math.abs(n)
  const sign = n < 0 ? '-' : ''

  if (abs < 1000) {
    return sign + '$' + Math.round(abs).toLocaleString()
  }

  if (abs < 1_000_000) {
    const k = abs / 1000
    // Show one decimal unless it's a round number
    const formatted = k % 1 === 0 ? k.toFixed(0) : k.toFixed(1)
    return sign + '$' + formatted + 'K'
  }

  const m = abs / 1_000_000
  const formatted = m % 1 === 0 ? m.toFixed(0) : m.toFixed(1)
  return sign + '$' + formatted + 'M'
}

/**
 * Ensure an external URL has a scheme so the browser doesn't treat it as a
 * relative path (e.g. "cloudconnect.io" -> "/suppliers/cloudconnect.io").
 * Returns null for empty input so callers can hide/disable the link.
 */
export function normalizeUrl(url?: string | null): string | null {
  const t = url?.trim()
  if (!t) return null
  return /^https?:\/\//i.test(t) ? t : `https://${t.replace(/^\/+/, '')}`
}
